"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEnabledLogHandlersForTransport = void 0;
var _applicationInsights = require("../../application-insights");
var _types = require("../../types");
var _pinoGroupedLogHandlers = require("../pino-log-handlers/pinoGroupedLogHandlers");
// Just checking if it could be somewhere enabled is enough to determine its usage<
var isTransportTypeEnabled = function(transportType, configuration) {
    return configuration.filters.some(function(filter) {
        return filter.enabled && filter.byTransportType === transportType;
    });
};
var getEnabledLogHandlersForTransport = function(param) {
    var loggerConfiguration = param.loggerConfiguration, applicationInsightsConfiguration = param.applicationInsightsConfiguration;
    var enabledLogHandlers = new Map();
    var isApplicationInsightsTransportEnabled = isTransportTypeEnabled(_types.LoggerTransportType.APPLICATION_INSIGHTS, loggerConfiguration);
    var isConsoleTransportEnabled = isTransportTypeEnabled(_types.LoggerTransportType.CONSOLE, loggerConfiguration);
    // Ensure that application insights is initialized on the other worker thread as pino does not log on the main thread
    if (isApplicationInsightsTransportEnabled && applicationInsightsConfiguration && !_applicationInsights.ApplicationInsights.isInitialized()) {
        global.oriAppInsightsSettings = applicationInsightsConfiguration;
        _applicationInsights.ApplicationInsights.initialize(applicationInsightsConfiguration);
    }
    if (isApplicationInsightsTransportEnabled && _applicationInsights.ApplicationInsights.isInitialized()) {
        enabledLogHandlers.set(_types.LoggerTransportType.APPLICATION_INSIGHTS, _pinoGroupedLogHandlers.pinoGroupedLogHandlers[_types.LoggerTransportType.APPLICATION_INSIGHTS]);
    }
    // Add console log handler as fallback
    if (isConsoleTransportEnabled || enabledLogHandlers.size === 0) {
        enabledLogHandlers.set(_types.LoggerTransportType.CONSOLE, _pinoGroupedLogHandlers.pinoGroupedLogHandlers[_types.LoggerTransportType.CONSOLE]);
    }
    return enabledLogHandlers;
};
exports.getEnabledLogHandlersForTransport = getEnabledLogHandlersForTransport; //# sourceMappingURL=getEnabledLogHandlersForTransport.js.map
